import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { AclNgxModule } from '@amobee/acl-ngx';
import { ReactComponentsModule } from '../../react-components/react-components.module';
import { AutoCompleteComponent } from './auto-complete.component';
import { HttpClientModule } from '@angular/common/http';
import { DirectivesModule } from './../../directives/directives.module';

@NgModule({
    declarations: [
        AutoCompleteComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA,
        NO_ERRORS_SCHEMA
    ],
    imports: [CommonModule, DirectivesModule, ReactiveFormsModule, AclNgxModule, ReactComponentsModule, HttpClientModule],
    exports: [AutoCompleteComponent]
})
export class AutoCompleteModule { }